import { FormField } from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useFormsTranslation } from '@/hooks/useTranslation';
import type { Control } from 'react-hook-form';
import { FormFieldWrapper } from '../../FormFieldWrapper';
import type { FormKData } from '../types/formK.types';

interface AdditionalQuestionsSectionProps {
  control: Control<FormKData>;
}

/**
 * Additional Questions Section Component
 * Handles yes/no questions for shareholders and fiduciary holding
 */
export function AdditionalQuestionsSection({
  control,
}: AdditionalQuestionsSectionProps) {
  const { t: tForms } = useFormsTranslation();

  return (
    <section
      className='space-y-6'
      aria-labelledby='additional-questions-heading'
    >
      <div className='flex items-center gap-2 mb-4'>
        <h4 id='additional-questions-heading' className='text-md font-medium'>
          {tForms('formK.sections.additionalQuestions')}
        </h4>
      </div>

      <div className='grid grid-cols-1 md:grid-cols-2 gap-4 items-start'>
        {/* Shareholders Other Companies Question */}
        <FormField
          control={control}
          name='shareholdersOtherCompanies'
          render={({ field, fieldState }) => (
            <FormFieldWrapper
              label={tForms('formK.fields.shareholdersOtherCompanies')}
              name='shareholdersOtherCompanies'
              required
              tooltip={tForms('formK.tooltips.shareholdersOtherCompanies')}
              error={fieldState.error?.message}
            >
              <Select value={field.value} onValueChange={field.onChange}>
                <SelectTrigger className='min-h-[44px] w-full'>
                  <SelectValue
                    placeholder={tForms('formK.placeholders.selectOption')}
                  />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value='yes'>
                    {tForms('formK.labels.yes')}
                  </SelectItem>
                  <SelectItem value='no'>
                    {tForms('formK.labels.no')}
                  </SelectItem>
                </SelectContent>
              </Select>
            </FormFieldWrapper>
          )}
        />

        {/* Fiduciary Holding Question */}
        <FormField
          control={control}
          name='fiduciaryHolding'
          render={({ field, fieldState }) => (
            <FormFieldWrapper
              label={tForms('formK.fields.fiduciaryHolding')}
              name='fiduciaryHolding'
              required
              tooltip={tForms('formK.tooltips.fiduciaryHolding')}
              error={fieldState.error?.message}
            >
              <Select value={field.value} onValueChange={field.onChange}>
                <SelectTrigger className='min-h-[44px] w-full'>
                  <SelectValue
                    placeholder={tForms('formK.placeholders.selectOption')}
                  />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value='yes'>
                    {tForms('formK.labels.yes')}
                  </SelectItem>
                  <SelectItem value='no'>
                    {tForms('formK.labels.no')}
                  </SelectItem>
                </SelectContent>
              </Select>
            </FormFieldWrapper>
          )}
        />
      </div>
    </section>
  );
}
